import { Component, EventEmitter, Input, Output } from '@angular/core';
import { JobListingItem } from '../../jobs-module/models/listing.model';
import { EditorText } from '../../shared-module/components/mj-text-editor/mj-text-editor.component';

@Component({
  selector: 'mj-job-free-text',
  templateUrl: './job-free-text.component.html',
  styleUrls: ['./job-free-text.component.scss'],
})
export class JobFreeTextComponent {
  @Input() public listingItem: JobListingItem;
  @Output() public onItemChanged = new EventEmitter<JobListingItem>();
  @Output() public onItemScheduledForRemoval = new EventEmitter();

  isColorPickerOn;

  saveText($event: EditorText) {
    this.onItemChanged.emit({
      ...this.listingItem,
      free_text_rich: $event.rich,
    });
  }
}
